import { render, staticRenderFns } from "./CompanyFileManager.vue?vue&type=template&id=6c97fdce&"
import script from "./CompanyFileManager.vue?vue&type=script&lang=js&"
export * from "./CompanyFileManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports